
import { 
  defineComponent, 
  computed,
  ref,
  SetupContext,
  PropType
} from "vue";
import NativeClient from "@/client/native-client";
import SelectingIngredientList from "@/components/common/SelectingIngredientList.vue";
import { SelectingIngredientListDataItem } from "@/types/common";
import { ShoppingListCategoryListItem } from "@/types/shoppingList"

/** スクロールイベントのIF */
interface HTMLElementEvent<T extends HTMLElement> extends Event {
  target: T;
}

export default defineComponent({
  name: "ShoppingListCategorySelectingIngredientList",
  components: { SelectingIngredientList },
  props: {
    /** 順番 */
    index: {
      type: Number,
      required: true
    },
    /** トータル個数 */
    totalCount: {
      type: Number,
      default: 0
    },
    /** 食材リスト */
    ingredientList: {
      type: Array as PropType<SelectingIngredientListDataItem[]>,
      default: () => null
    }
  },
  setup(props, context: SetupContext) {
    const nodataMessage = "食材の候補はありません";

    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    //
    // 追加読み込み判定
    //
    // スクロール検知
    const onScroll = (event: HTMLElementEvent<HTMLDivElement>) => {
      NativeClient.sendDebugLog("ShoppingListCatogorySelectingIngredientList onScroll");
      if (props.ingredientList == null || props.totalCount <= props.ingredientList.length) {
        NativeClient.sendDebugLog("ShoppingListCatogorySelectingIngredientList onScroll categoryList is null or already read all items");
        return;
      }
      // if ((event.target.scrollTop + event.target.offsetHeight) >= (event.target.scrollHeight - 1)) {
      //   NativeClient.sendDebugLog("ShoppingListCatogorySelectingIngredientList onScroll screen bottom");
      //   context.emit("request-read", props.index);
      // }
    };

    const checkFoodAction = (id: number | null, name: string, isSelect: boolean) => {
      NativeClient.sendDebugLog("ShoppingListCatogorySelectingIngredientList checkFoodAction id = " + id + ", name = " + name + ", isSelect = " + isSelect);
      context.emit("check-ingredient", props.index, id, name, isSelect);
    };

    return {
      updateDisplayKey,
      nodataMessage,
      onScroll,
      checkFoodAction
    };
  }
});
